import { Fragment } from "react";
import { Link } from "react-router-dom";
import { CASINO_GAME_LISTS } from "../../../config/casinoCategoryLists";

// Reference banner thumbnails (cdn.926assets.com/.../admin/img/banners/*), stored in assets/images/thumbs.
const THUMBS = import.meta.glob("../../../assets/images/thumbs/*.{jpg,gif}", {
  eager: true,
  query: "?url",
  import: "default",
});
const thumb = (file) => THUMBS[`../../../assets/images/thumbs/${file}`];

// Wrapper differences the reference's per-list templates have (everything else is identical):
// liveteenpattilist has no `.row` on the container; lucky7list closes the inner <div></div> before it.
const NO_ROW_LISTS = new Set(["liveteenpatti"]);
const SPLIT_WRAPPER_LISTS = new Set(["lucky7"]);

/**
 * Casino game list page — reference markup (allpanel9.global/admin/casino/<list>):
 * .featured-box > div > .row.diamond-casino-container.mt-3 > (.casino-box > a > .casino-icons > img.img-fluid) + " "
 */
export default function CasinoGameList({ listKey }) {
  const games = CASINO_GAME_LISTS[listKey] || [];
  const container = (
    <div className={NO_ROW_LISTS.has(listKey) ? "diamond-casino-container mt-3" : "row diamond-casino-container mt-3"}>
      {games.map((game, i) => (
        <Fragment key={game.path}>
          {i > 0 && " "}
          <div className="casino-box">
            <Link to={game.path}>
              <div className="casino-icons">
                {/* reference: only worli3.gif carries height/width="100%" */}
                {game.video ? (
                  // teen20v1_admin.gif is really an MP4 (broken <img> on the reference too): play it as a video
                  <video src={thumb(game.img)} className="img-fluid" autoPlay muted loop playsInline />
                ) : game.img === "worli3.gif" ? (
                  <img src={thumb(game.img)} height="100%" width="100%" className="img-fluid" />
                ) : (
                  <img src={thumb(game.img)} className="img-fluid" />
                )}
              </div>
            </Link>
          </div>
        </Fragment>
      ))}
    </div>
  );
  return (
    <div className="col-md-12 featured-box">
      {SPLIT_WRAPPER_LISTS.has(listKey) ? (
        <>
          <div></div> {container}
        </>
      ) : (
        <div>{container}</div>
      )}
    </div>
  );
}
